module.exports = __webpack_public_path__ + "img/neurological_exam_splash.7c6e472e.jpg";